export const APP_TIME_ZONE = 'Africa/Casablanca';

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const getAppDateInputValue = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);

  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const formatAppDate = (value, locale = 'fr-CA', options = {}) => {
  if (!value) return '-';

  // A YYYY-MM-DD value represents a calendar day, not a UTC timestamp.
  // Formatting it in UTC prevents an off-by-one-day conversion in another browser timezone.
  if (typeof value === 'string' && DATE_ONLY_PATTERN.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
      ...options
    }).format(new Date(Date.UTC(year, month - 1, day, 12)));
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: APP_TIME_ZONE,
    ...options
  }).format(date);
};
